import { IconBaseChain } from './Base';
import { IconEthereum } from './Ethereum';
import { IconSolana } from './Solana';
export const IconChain = {
    Base: IconBaseChain,
    Ethereum: IconEthereum,
    Solana: IconSolana,
};
//# sourceMappingURL=index.js.map